import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getMapAPI } from "../../../api/map";
import { getPositionTypesError, getPositionTypesSuccess } from "./actions";
// Login Redux States
import { GET_POSITION_TYPES } from "./actionTypes";

const mapAPI = getMapAPI();

function* getPositionTypesApi({ payload: { user } }) {
  try {
    const response = yield call(mapAPI.getPositionTypes, user.token);
    yield put(getPositionTypesSuccess(response.message, response.position_types));
  } catch (error) {
    yield put(getPositionTypesError(error));
  }
}

export function* watchGetPositionTypes() {
  yield takeEvery(GET_POSITION_TYPES, getPositionTypesApi);
}

function* getPositionTypesSaga() {
  yield all([fork(watchGetPositionTypes)]);
}

export default getPositionTypesSaga;
